import { AHInput, Box } from "arkh";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";

export const InstructionsInput = ({
  setInstructions,
  instructions,
}: {
  instructions: string;
  setInstructions(_: string): void;
}) => {
  const intl_tokens = useIntlTokens();

  return (
    <Box spaceHorizontal="small">
      <AHInput
        spaceVertical="xsmall"
        spaceHorizontal="small"
        style={{ lineHeight: 17 }}
        placeholder={intl_tokens.Description}
        autoCapitalize="sentences"
        multiline
        value={instructions}
        onChangeText={setInstructions}
      />
    </Box>
  );
};
